let incrementInput = function (e, step = 1) {
  let input = getSiblings(e).filter(function (sibling) {
    return sibling.tagName == 'INPUT';
  })[0];
  let inputValue = input.value == '' ? 0 : parseInt(input.value);
  let pow = Math.floor(Math.log10(inputValue));
  let decimal = Math.pow(10, pow);
  let decimalM1 = Math.pow(10, pow - 1);
  // Even after it took me a solid bit
  // I am proud of this one
  // Also exp+ will increment only in row of whole numbers meaning
  // 70001 => 80001
  // Fix would be to simply expand exp+ for same logic as exp-
  // IMO this would be da way
  if (step == 'exp+') {
    console.log(Math.log10(inputValue));
    if (Math.log10(inputValue) >= 1) {
      input.value = Math.floor((inputValue + decimal) / decimal) * decimal;
    } else {
      input.value = inputValue + 1;
    }
  } else if (step == 'exp-') {
    if (Math.log10(inputValue) >= 1) {
      if (inputValue / decimal > 1) {
        input.value = Math.floor((inputValue - decimal) / decimal) * decimal;
      } else {
        console.log(Math.floor(inputValue - Math.pow(10, pow - 1)));
        input.value =
          Math.floor((inputValue - decimalM1) / decimalM1) * decimalM1;
      }
    } else {
      input.value = inputValue - 1;
    }
  } else {
    input.value = inputValue + step;
  }
  return false;
};
let changePropertyPrice = function (e, step) {
  var input = $('#mortgage_form_propertyPrice');
  var inputMortgageAmount = $('#mortgage_form_mortgageAmount');
  var inputValue = parseInt(input.data('value'));
  var inputValueMortgageAmount = parseInt(inputMortgageAmount.data('value'));
  if (step === '+') {
    if (inputValue < 25000000) {
      inputValue += 100000;
      input.data('value', inputValue);
      input.val(Number(inputValue).toLocaleString());
    }
  } else {
    if (inputValue > 300000) {
      inputValue -= 100000;
      input.data('value', inputValue);
      input.val(Number(inputValue).toLocaleString());
    }
    if (inputValueMortgageAmount * 1.1 > inputValue) {
      inputMortgageAmount.data('value', inputValue * 0.9);
      inputMortgageAmount.val(Number(inputValue * 0.9).toLocaleString());
    }
  }
};
let changeMortgageAmount = function (e, step) {
  var input = $('#mortgage_form_mortgageAmount');
  var inputPropertyPrice = $('#mortgage_form_propertyPrice');
  var inputValue = parseInt(input.data('value'));
  var inputValuePropertyPrice = parseInt(inputPropertyPrice.data('value'));
  if (step === '+') {
    if (inputValue < 25000000) {
      inputValue += 100000;
      input.data('value', inputValue);
      input.val(Number(inputValue).toLocaleString());
    }
    if (inputValue * 1.1 > inputValuePropertyPrice) {
      inputPropertyPrice.data('value', inputValue * 1.1);
      inputPropertyPrice.val(Number(inputValue * 1.1).toLocaleString());
    }
  } else {
    if (inputValue > 300000) {
      inputValue -= 100000;
      input.data('value', inputValue);
      input.val(Number(inputValue).toLocaleString());
    }
  }
};
$(function () {
  var mortgageAmount = $('#mortgage_form_mortgageAmount');
  var propertyPrice = $('#mortgage_form_propertyPrice');
  if (mortgageAmount.length) {
    mortgageAmount.val(Number(mortgageAmount.val()).toLocaleString());
  }

  if (propertyPrice.length) {
    propertyPrice.val(Number(propertyPrice.val()).toLocaleString());
  }

  mortgageAmount.keyup(function () {
    var value = $(this).val().replace(/\D/g, '');
    $(this).val(Number(value).toLocaleString());
    $(this).data('value', value);
  });

  propertyPrice.keyup(function () {
    var value = $(this).val().replace(/\D/g, '');
    $(this).val(Number(value).toLocaleString());
    $(this).data('value', value);
  });

  mortgageAmount.on('change', function () {
    var value = $(this).data('value');
    if (value < 300000) {
      $(this).val(Number(300000).toLocaleString());
      $(this).data('value', 300000);
      value = 300000;
    }

    if (value > 25000000) {
      $(this).val(Number(25000000).toLocaleString());
      $(this).data('value', 25000000);
      value = 25000000;
    }

    if (value * 1.1 > propertyPrice.data('value')) {
      propertyPrice.data('value', value * 1.1);
      propertyPrice.val(Number(value * 1.1).toLocaleString());
    }
  });

  propertyPrice.on('change', function () {
    var value = $(this).data('value');
    if (value < 300000) {
      $(this).val(Number(300000).toLocaleString());
      $(this).data('value', 300000);
      value = 300000;
    }

    if (value > 25000000) {
      $(this).val(Number(25000000).toLocaleString());
      $(this).data('value', 25000000);
      value = 25000000;
    }

    if (mortgageAmount.data('value') * 1.1 > value) {
      mortgageAmount.data('value', value * 0.9);
      mortgageAmount.val(Number(value * 0.9).toLocaleString());
    }
  });

  var buttonCompare = $('#button-compare');
  buttonCompare.on('click', function (e) {
    e.preventDefault();
    mortgageAmount.val(mortgageAmount.data('value'));
    propertyPrice.val(propertyPrice.data('value'));
    $('#mortgage-form').submit();
  });

  $('#iam_interest_contact_form_phoneNumber').keyup(function () {
    $(this).val($(this).val().replace(/\D/g, '').replace('420', ''));
  });
});
$('#mortgage_form_dueDate').on('change', function () {
  if ($(this).val() < 1) {
    $(this).val(1);
  }

  if ($(this).val() > 40) {
    $(this).val(40);
  }
});
let changeDueDate = function (e, step) {
  let input = getSiblings(e).filter(function (sibling) {
    return sibling.tagName == 'INPUT';
  })[0];
  let inputValue = input.value == '' ? 0 : parseInt(input.value);
  if (step === '+') {
    if (inputValue < 40) {
      input.value = inputValue + 1;
    }
  } else {
    if (inputValue > 1) {
      input.value = inputValue - 1;
    }
  }
};
$('#mortgage_form_fixation').on('change', function () {
  if ($(this).val() < 1) {
    $(this).val(1);
  }

  if ($(this).val() > 15) {
    $(this).val(15);
  }
});
let changeFixation = function (e, step) {
  let input = getSiblings(e).filter(function (sibling) {
    return sibling.tagName == 'INPUT';
  })[0];
  let inputValue = input.value == '' ? 0 : parseInt(input.value);
  if (step === '+') {
    switch (inputValue) {
      case 1:
        input.value = 2;
        return;
      case 2:
        input.value = 3;
        return;
      case 3:
        input.value = 5;
        return;
      case 5:
        input.value = 7;
        return;
      case 7:
        input.value = 8;
        return;
      case 8:
        input.value = 9;
        break;
      case 9:
        input.value = 10;
        break;
      case 10:
        input.value = 15;
        break;
      case 15:
        input.value = 15;
        break;
    }
  } else {
    switch (inputValue) {
      case 1:
        input.value = 1;
        return;
      case 2:
        input.value = 1;
        return;
      case 3:
        input.value = 2;
        return;
      case 5:
        input.value = 3;
        return;
      case 7:
        input.value = 5;
        return;
      case 8:
        input.value = 7;
        break;
      case 9:
        input.value = 8;
        break;
      case 10:
        input.value = 9;
        break;
      case 15:
        input.value = 10;
        break;
    }
  }
};
let redirectToStepThree = function (e) {
  let urlToRedirect = $(e).data('url');
  window.location.href = urlToRedirect;
};

// Mortgage calculator
let getSiblings = function (e) {
  // for collecting siblings
  let siblings = [];
  // if no parent, return no sibling
  if (!e.parentNode) {
    return siblings;
  }
  // first child of the parent node
  let sibling = e.parentNode.firstChild;
  // collecting siblings
  while (sibling) {
    if (sibling.nodeType === 1 && sibling !== e) {
      siblings.push(sibling);
    }
    sibling = sibling.nextSibling;
  }
  return siblings;
};
$('#button-sent-mortgage-offer').on('click', function (e) {
  var form = $(this).closest('form');
  var checkbox = $('#iam_interest_contact_form_agree');
  if (form[0].checkValidity()) {
    e.preventDefault();
    $('.error-messages').remove();
    if (checkPhoneInput()) {
      if (checkbox.prop('checked')) {
        form.submit();
      } else {
        $('.form--agreement').append(
          '<span class="error-messages">' + checkbox.data('error') + '</span>'
        );
      }
    }
  }
});

function checkPhoneInput() {
  var phoneInput = $('#iam_interest_contact_form_phoneNumber');
  if (phoneInput.val().length !== 9) {
    phoneInput
      .parent()
      .append(
        '<span class="error-messages" style="padding-left: 0;padding-top: 5px;">Vyplňtě prosím správné číslo</span>'
      );
    return false;
  } else {
    $('.error-messages').remove();
    return true;
  }
}
